module.exports = __webpack_public_path__ + "static/media/YF63_1.216b6778.jpg";